import vSelect from 'vue-select'

import { required, image, size } from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import TicketService from '@/services/apis/tickets'
import { isModuleEnabled, resizeImage } from '@/utils'
import MetatraderService from '@/modules/forex/service/apis'

const metaTrader = new MetatraderService()

const { createNewTicket, getTicketCategory } = new TicketService()
export default {
  components: {
    vSelect,
    FeatherIcon,
  },

  data() {
    return {
      show: true,
      isLoading: false,
      categories: [],
      required,
      image,
      size,
      accountsItems: [],
      platforms: [],
      selectedCategory: {},
      form: {
        title: '',
        context: '',
        platform: '',
        platformAccount: '',
        file: null,
      },
      isModuleEnabled,
    }
  },
  computed: {
    MAX_IMAGE_UPLOAD_SIZE() {
      return process.env.VUE_APP_MAX_IMAGE_UPLOAD_SIZE
    },
  },
  created() {
    getTicketCategory()
      .then(({ data }) => {
        this.categories = data.results
      })
      .finally(() => {
        this.show = false
      })
    if (isModuleEnabled('FOREX')) {
      this.getPlatform()
    }
  },

  methods: {
    onAccountChange() {
      this.getAccounts()
    },
    async getPlatform() {
      this.show = true
      await metaTrader.getPlatforms().then(res => {
        this.platforms = res.data.results
      }).finally(() => {
        this.show = false
      })
    },
    async getAccounts() {
      this.show = true
      await metaTrader.getAccounts({ platform: this.form.platform.value }).then(res => {
        // eslint-disable-next-line prefer-destructuring
        this.accountsItems = res.data.results
      }).finally(() => {
        this.show = false
      })
    },
    async onSubmit() {
      this.isLoading = true
      const imageSize = (process.env.VUE_APP_RESIZE_IMAGE_SIZE
        ? process.env.VUE_APP_RESIZE_IMAGE_SIZE
        : 3072) * 1024
      const compressedFile = this.form.file
        ? await resizeImage(this.form.file, imageSize)
        : null
      const newTicket = {
        ticket_category_id: this.selectedCategory.id,
        context: this.form.context,
        title: this.form.title,
        platform: this.form.platform.value,
        account: this.form.platformAccount.account,
        file: compressedFile,
      }

      createNewTicket(newTicket)
        .then(({ data }) => {
          this.$swal({
            title: data?.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.$router.push({ name: 'tickets' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    categorySelecting(item) {
      this.selectedCategory = item
    },
  },
}
